import { render, staticRenderFns } from "./OperaCouponDetail.vue?vue&type=template&id=db91a9ee&scoped=true&"
import script from "./OperaCouponDetail.vue?vue&type=script&lang=js&"
export * from "./OperaCouponDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db91a9ee",
  null
  
)

export default component.exports